// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Ouv","left":"styles_left___hEEg","right":"styles_right__3Hjy5","alert":"styles_alert__366YS"};